import { Firebase } from "../managers/FirebaseManager";
import { UserCodeType } from "../types/user";

export const getUserByCode = async (userCode: string) => {
  const codeResponse = await Firebase.get("userCodes");
  const userCodes = Object.values(codeResponse?.val());

  return userCodes.find((item: any) => item.code === userCode) as UserCodeType;
};
